/*
 *
 * Achievements actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';
import { Achievement } from './achievements';

export const fetchAchievements = createAction<boolean>(
  `${SLICE_NAME}/fetchAchievements`,
);

export const updateAchievement = createAction<Achievement>(
  `${SLICE_NAME}/updateAchievement`,
);

export const deleteAchievement = createAction<string>(
  `${SLICE_NAME}/deleteAchievement`,
);
